// CMS data selectors
export const homeCmsData = (state) =>
  state.cms?.data?.["pages/home"]?.results?.[0]?.Sections;
export const footerCmsData = (state) =>
  state.cms?.data?.["pages/home"]?.results?.[0]?.Sections?.footer;
export const globalCmsData = (state) =>
  state.cms?.data?.global?.results?.[0]?.shared;
export const loginCmsDataSelector = (state) =>  state.cms?.data?.["pages/loginSignup"]?.results?.[0]